export default __webpack_public_path__ + "static/media/genuine-page.06cea82b.png";